import type React from 'react'

/**
 * Wrapper that forwards the ref and all event handlers from Tooltip's cloneElement
 * but strips `aria-describedby` which we will manually connect to an element.
 * This is needed to properly associate the tooltip with the pickers' anchor.
 */
export const TooltipTriggerWrapper = ({
  ref,
  'aria-describedby': _ariaDescribedBy,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & {ref?: React.RefObject<HTMLSpanElement | null>}) => (
  <span ref={ref} {...props} />
)
TooltipTriggerWrapper.displayName = 'TooltipTriggerWrapper'
